<template>
  <v-select
    v-model="selected"
    :items="options"
    item-text="Name"
    item-value="value"
    filled
    readonly
    dense
    hide-details="true"
    label="Frequency"
    id="frequency_ddl"
    @input="val => $emit('input', val)"
    ref="select"
  >
  </v-select>
</template>

<script>
import StyledSelect from '@/components/common/dropDownList/StyledSelectVModel'
import {FREQUENCIES, ADSTRA_FREQUENCIES, FREQUENCY_OPTION_SET} from '@/appLogic/targets/Constants'

const ONE_TIME = { Name: 'One Time', value: FREQUENCIES.ONE_TIME }
const WEEKLY = { Name: 'Weekly', value: FREQUENCIES.WEEKLY }
const MONTHLY = { Name: 'Monthly', value: FREQUENCIES.MONTHLY }
const QUARTERLY = { Name: 'Quarterly', value: FREQUENCIES.QUARTERLY }

export default {
  components: {
    StyledSelect
  },
  props: {
    initialValue: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optionSet: {
      type: Number,
      default: FREQUENCY_OPTION_SET.LINEAR
    },
  },
  computed: {
    selected: {
      get () {
        return this.initialValue || ''
      },
      set (newVal) {
        // No action needed
      },
    },
    options () {
      switch (this.optionSet) {
        case FREQUENCY_OPTION_SET.ADSTRA:
          return [MONTHLY]
        case FREQUENCY_OPTION_SET.DIGITAL:
          return [WEEKLY]
        case FREQUENCY_OPTION_SET.VIZIO:
          return [WEEKLY]
        case FREQUENCY_OPTION_SET.DIRECTV:
          return [ONE_TIME]
        case FREQUENCY_OPTION_SET.CANOE_LINEAR:
          return [WEEKLY]
        case FREQUENCY_OPTION_SET.CANOE_VOD:
          return [WEEKLY]
        case FREQUENCY_OPTION_SET.LINEAR:
          return [ONE_TIME, QUARTERLY]
        case FREQUENCY_OPTION_SET.XANDR_SOCIAL_DIGITAL:
          return [WEEKLY]
        default:
          return [ONE_TIME, WEEKLY, MONTHLY]
      }
    },
  },
  methods: {
    clear () {
      this.$refs.select.clear()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// FrequencyDDL.vue?f2378304